import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import heroBg from "@/assets/hero-botanical.webp";

// Preload the LCP hero image as early as possible
const heroPreload = document.createElement("link");
heroPreload.rel = "preload";
heroPreload.as = "image";
heroPreload.href = heroBg;
heroPreload.fetchPriority = "high";
document.head.appendChild(heroPreload);

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);
